export const errors = {
  "403": "Vous n'avez pas accès à cette page.",
  "404": "Cette page ne semble pas exister.\nElle a peut-être été supprimée ou déplacée.",
  "500": "L'application a rencontré une erreur inconnue. Réessayez dans quelques instants.",
  "502": "Quelque chose s'est mal passé. Réessayez dans quelques instants.",
  "403_action": "Vous n'avez pas la permission d'effectuer cette action.",
  "404_action": "Cet objet n'existe pas.\nIl a peut-être été supprimé ou déplacé.",
  authError: "Une erreur s'est produite lors du processus de connexion. Veuillez réessayer.",
  authLinkError:
    "Quelque chose s'est mal passé. Vous avez probablement utilisé la mauvaise URL pour accéder à cette page. Retournez à l'accueil et réessayez.",
  fetch_error: "Le réseau est inaccessible. Réessayez dans quelques instants.",
  incorrect_url: "Cette URL est incorrecte.",
  no_tenant: "Vous devriez contacter un administrateur.",
  superadmin_no_tenant: "Vous devriez d'abord choisir le locataire, ou définir celui par défaut.",
  Take_me_home: "Ramenez-moi à l'accueil",
  Try_again: "Réessayer",
  unknown: "L'application a rencontré une erreur inconnue. Réessayez dans quelques instants.",
  if_error_persists: "Si l'erreur persiste, veuillez contacter l'<a>équipe de support</a>",
  mapping_download_error: "Une erreur s'est produite lors du téléchargement de la cartographie",
} as const;
